import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import { JOURNAL_ORDER_DESER, JournalOrder } from "./journal-order"

export class JournalEntry {
  id = ""
  title = ""
  content = ""
  tags: string[] = []
  createdAt: Date | null = null
  updatedAt: Date | null = null
  order: JournalOrder | null = null
}

export const JOURNAL_ENTRY_DESER: SchemaDeSer<JournalEntry> =
  new SchemaDeSerBuilder(JournalEntry)
    .ofStrings("id", "title", "content")
    .ofPrimitiveArray("tags")
    .ofDateTime("createdAt")
    .ofDateTime("updatedAt")
    .ofNested("order", JOURNAL_ORDER_DESER, JournalOrder)
    .toDeSer()
